// Centralized WhatsApp/Tintim tracking link for all CTAs
export const WHATSAPP_LINK = "https://tintim.link/whatsapp/6c3d0109-1f9c-457d-b8ce-dc8edfaac323/9ac2598f-6922-4efc-bb2a-066abe7613e8";

// Direct WhatsApp link used as fallback (same tracking link so all buttons route through Tintim)
export const WHATSAPP_DIRECT = "https://tintim.link/whatsapp/6c3d0109-1f9c-457d-b8ce-dc8edfaac323/9ac2598f-6922-4efc-bb2a-066abe7613e8";
